export default __webpack_public_path__ + "static/media/background.8a9ec7e3.png";